export default {
  workerManagerApi: {
    workerManager: {
      getList: '/api/workerManager/getList',
      getDetail: '/api/workerManager/getDetail',
      saveOrUpdate: '/api/workerManager/saveOrUpdate',
      del: '/api/workerManager/del',
      getWorkerRoles: '/api/workerManager/getWorkerRoles',
      findLastTemplateByTypeIds: '/api/workOrderConfig/findLastTemplateByTypeIds'
    },
  }
}
